<div class="version-container no-print">
  <span class="binu-version-tag">v{{ erpVersion }}</span>
  
  <div class="binu-tooltip">
    <div class="d-flex flex-column">
      <span><b>Name:</b> {{ erpName }}</span>
      <span><b>Version:</b> {{ erpVersion }}</span>
      <span><b>Build Date:</b> {{ buildDate }}</span>
    </div>
  </div>
</div>
